/*
 * Blog — poradnik: przewijanie pasa kart strzałkami i przeciąganiem myszą.
 * Bez tego skryptu pas dalej przewija się palcem/kółkiem — strzałki
 * są w HTML-u ukryte (`hidden`) i odkrywamy je dopiero tutaj.
 *
 * Ruch robimy SAMI (rAF + ease-out), a nie przez scrollBy + scroll-snap:
 * wcześniej rozpęd z przeciągnięcia dokładał się do dociągania snapu
 * i pas przeskakiwał o kilka kart naraz. Teraz zawsze liczymy konkretną
 * kartę docelową i jedziemy dokładnie do jej krawędzi. Na czas ruchu klasa
 * `jest-ruch` zdejmuje scroll-snap i smooth (inaczej przeglądarka walczy
 * z animacją), po dojechaniu pozycja już leży na karcie, więc snap nie
 * rusza pasa.
 *
 * - strzałki: jedna karta na klik; szybkie klikanie liczy od karty
 *   docelowej, nie od bieżącej pozycji (bez gubienia kliknięć),
 * - przeciąganie myszą (palec przewija natywnie, tylko pointerType
 *   'mouse'): pas idzie 1:1 za kursorem, po puszczeniu jedzie do
 *   najbliższej karty; szybki ruch ręki dokłada najwyżej jedną kartę,
 * - ruch i puszczenie słuchamy na window, BEZ setPointerCapture — capture
 *   zabija potem click w linkach pod pasem (pułapka ze Społeczności),
 * - klik po przeciągnięciu (>6 px) jest anulowany, żeby nie otwierać wpisu.
 */
(function () {
  var PROG = 6; // px — poniżej to klik, powyżej przeciągnięcie

  function init(sekcja) {
    if (sekcja.__blog) return;
    sekcja.__blog = true;

    var pas = sekcja.querySelector('[data-blog-pas]');
    var strzalki = sekcja.querySelector('[data-blog-strzalki]');
    if (!pas || !strzalki) return;
    var wstecz = strzalki.querySelector('[data-blog-wstecz]');
    var dalej = strzalki.querySelector('[data-blog-dalej]');
    var bezRuchu = window.matchMedia('(prefers-reduced-motion: reduce)');

    // ── Pozycje kart (scrollLeft, przy którym karta stoi przy lewej krawędzi)
    function pozycje() {
      var max = pas.scrollWidth - pas.clientWidth;
      var lewo = pas.getBoundingClientRect().left + (parseFloat(getComputedStyle(pas).scrollPaddingLeft) || 0);
      var wynik = [];
      pas.querySelectorAll('.blog-karta').forEach(function (k) {
        var x = Math.round(k.getBoundingClientRect().left - lewo + pas.scrollLeft);
        x = Math.max(0, Math.min(max, x));
        if (!wynik.length || x - wynik[wynik.length - 1] > 1) wynik.push(x);
      });
      return wynik.length ? wynik : [0];
    }

    function najblizsza(lista, x) {
      var nr = 0;
      for (var i = 1; i < lista.length; i++) {
        if (Math.abs(lista[i] - x) < Math.abs(lista[nr] - x)) nr = i;
      }
      return nr;
    }

    // ── Animacja
    var anim = null; // { cel, nr, raf }

    function stop() {
      if (anim) cancelAnimationFrame(anim.raf);
      anim = null;
      pas.classList.remove('jest-ruch');
    }

    function jedz(nr, lista) {
      lista = lista || pozycje();
      nr = Math.max(0, Math.min(lista.length - 1, nr));
      var cel = lista[nr];
      var od = pas.scrollLeft;
      var droga = cel - od;
      if (anim) cancelAnimationFrame(anim.raf);
      if (Math.abs(droga) < 1 || bezRuchu.matches) {
        pas.scrollLeft = cel;
        anim = null;
        pas.classList.remove('jest-ruch');
        odswiez();
        return;
      }
      pas.classList.add('jest-ruch');
      // 350–650 ms zależnie od drogi — krótki ruch nie ciągnie się, długi nie szarpie
      var czas = Math.max(350, Math.min(650, 250 + Math.abs(droga) * 0.6));
      var t0 = performance.now();
      anim = { cel: cel, nr: nr, raf: 0 };
      (function klatka(teraz) {
        var t = Math.min(1, (teraz - t0) / czas);
        var e = 1 - Math.pow(1 - t, 3); // ease-out cubic
        pas.scrollLeft = od + droga * e;
        if (t < 1) {
          anim.raf = requestAnimationFrame(klatka);
        } else {
          anim = null;
          pas.classList.remove('jest-ruch');
          odswiez();
        }
      })(t0);
    }

    // ── Strzałki
    function krok(kierunek) {
      var lista = pozycje();
      var obecna = anim ? anim.nr : najblizsza(lista, pas.scrollLeft);
      jedz(obecna + kierunek, lista);
    }

    function odswiez() {
      var max = pas.scrollWidth - pas.clientWidth;
      strzalki.hidden = max <= 2;
      var x = anim ? anim.cel : pas.scrollLeft;
      wstecz.disabled = x <= 2;
      dalej.disabled = x >= max - 2;
    }

    wstecz.addEventListener('click', function () {
      krok(-1);
    });
    dalej.addEventListener('click', function () {
      krok(1);
    });

    // ── Przeciąganie myszą
    var ciag = null;
    var anulujKlik = false;

    pas.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (pas.scrollWidth <= pas.clientWidth) return;
      stop();
      ciag = { x: e.clientX, start: pas.scrollLeft, ruszyl: false, probki: [] };
      anulujKlik = false;
    });

    window.addEventListener('pointermove', function (e) {
      if (!ciag) return;
      var dx = e.clientX - ciag.x;
      if (!ciag.ruszyl) {
        if (Math.abs(dx) < PROG) return;
        ciag.ruszyl = true;
        pas.classList.add('jest-ruch', 'jest-ciagniety');
      }
      e.preventDefault();
      var teraz = performance.now();
      ciag.probki.push({ x: e.clientX, t: teraz });
      while (ciag.probki.length > 2 && teraz - ciag.probki[0].t > 100) ciag.probki.shift();
      pas.scrollLeft = ciag.start - dx;
    });

    function pusc() {
      if (!ciag) return;
      var byl = ciag;
      ciag = null;
      if (!byl.ruszyl) return;
      anulujKlik = true;
      pas.classList.remove('jest-ciagniety');

      // Prędkość ręki z ostatnich ~100 ms (px/ms, + = kursor w prawo)
      var v = 0;
      var p = byl.probki;
      if (p.length >= 2 && performance.now() - p[p.length - 1].t < 80) {
        v = (p[p.length - 1].x - p[0].x) / Math.max(1, p[p.length - 1].t - p[0].t);
      }

      var lista = pozycje();
      var nr = najblizsza(lista, pas.scrollLeft);
      // Szybki ruch (>0,4 px/ms) = o jedną kartę dalej w stronę ruchu,
      // chyba że najbliższa karta już leży w tę stronę
      if (Math.abs(v) > 0.4) {
        var wPrawo = v < 0; // kursor w lewo = pas w prawo = kolejne karty
        if (wPrawo && lista[nr] <= pas.scrollLeft) nr++;
        if (!wPrawo && lista[nr] >= pas.scrollLeft) nr--;
      }
      jedz(nr, lista);
    }
    window.addEventListener('pointerup', pusc);
    window.addEventListener('pointercancel', pusc);

    pas.addEventListener('click', function (e) {
      if (!anulujKlik) return;
      anulujKlik = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    // Bez tego przeglądarka łapie link/obrazek do „przeciągnij i upuść"
    pas.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Kółko / gładzik / palec w trakcie animacji — oddajemy sterowanie
    pas.addEventListener('wheel', function () {
      if (anim) stop();
    }, { passive: true });
    pas.addEventListener('touchstart', function () {
      if (anim) stop();
    }, { passive: true });

    pas.addEventListener('scroll', function () {
      if (!anim) odswiez();
    }, { passive: true });
    window.addEventListener('resize', odswiez);
    odswiez();
  }

  function start() {
    document.querySelectorAll('[data-blog-poradnik]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Edytor motywu przeładowuje sekcję bez przeładowania strony
  document.addEventListener('shopify:section:load', start);
})();
